<template>
  <div>
    <router-view></router-view>
    <notification-modal/>
    <confirm-action-modal @confirm="confirm"/>
  </div>
</template>

<script>
import NotificationModal from "@/views/modal/NotificationModal";
import ConfirmActionModal from "@/views/modal/ConfirmActionModal";

export default {
  name: 'App',
  components: {ConfirmActionModal, NotificationModal},
  methods: {
    confirm(value) {
      this.$store.commit("action/onSetActionStatus", value)
    }
  }
}
</script>

<style lang="scss">
// Import Main styles for this application
@import 'assets/scss/style';
</style>
